export const PMO_PACKAGE_NAME = 'Ascend PMO'
export const US_REGION = 'US'

export interface ILeadCountriesObject {
  country_id: number;
  country_nm: string;
  instance_id: number;
  instance_name: string;
  lead_country_preference_order?: number;
}
